import React from 'react';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from "react-lazy-load-image-component";
import Css from './ImageItem.module.css';
import loading from './../../../../../../../img/loading.png';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { SwiperSlideDev } from './SwiperSlide/SwiperSlideDev';


function ImageItem(props) {
  const [valueFocus, setValueFocus] = React.useState(true);
  const [valueBlur, setValueBlur] = React.useState("blur");

  const MouseOutImages = () => {
    setValueFocus(false);

  }
  const MouseOverImages = () => {
    setValueFocus(true);
    setValueBlur("blur")
  }
  
  // onMouseLeave={MouseOverImages} onMouseLeave={MouseOverImages}
  return (

    <a href={`/${props.code}/`} onClick={()=>window.scrollTo({top: 0, behavior: 'smooth'})}>
      <div className={Css.contant} onMouseEnter={MouseOutImages} >
        {valueFocus ?
          <LazyLoadImage src={props.image} loading="lazy" width={"100%"} height={"100%"} effect={valueFocus ? "blur" : ""} placeholderSrc={loading} />
          :
          <SwiperSlideDev {...props} ImagesItems={props.images} />
        }
      </div>
    </a>
  );
}

export default ImageItem;